import { X, Footprints, Map, Utensils, Medal, Store, Crown, Soup, GraduationCap, Flame, Target, Dices, Trophy, Ticket, Lock } from "lucide-react";
import { toast } from "sonner";

const ICONS = {
  "pehli-pauri": Footprints, "pind-explorer": Map, "chaat-challenger": Utensils,
  "punjab-khiladi": Medal, "dhaba-champion": Store, "urban-legend": Crown,
  "masala-ustaad": Soup, "flavor-ustaad": GraduationCap, "satt-din": Flame,
  "challa-champ": Target, "saap-jetu": Dices, "pind-champion": Trophy, "patti-lucky": Ticket,
};

export const badgeToast = (badges) => {
  (badges || []).forEach((b) =>
    toast.success(`NEW BADGE — ${b.name} · ${b.pa}`, {
      style: { background: "#1C160A", color: "#D4AF37", border: "1px solid rgba(212,175,55,0.5)" } }));
};

export const MelaCoin = ({ size = 16, className = "" }) => (
  <img src="/mela/coin.png" alt="Regal Coin" width={size} height={size}
    className={`inline-block object-contain shrink-0 ${className}`} />
);

export const melaToast = (message) => toast.success(
  <span className="flex items-center gap-2"><MelaCoin size={20} /> {message}</span>,
  { style: { background: "#1A1A1A", color: "#F0C742", border: "1px solid rgba(212,175,55,0.4)" } });

export const BadgesSheet = ({ badges, onClose }) => {
  const earned = badges.filter((b) => b.earned).length;
  return (
    <div data-testid="badges-sheet" onClick={onClose}
      className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center">
      <div onClick={(e) => e.stopPropagation()}
        className="w-full sm:max-w-lg max-h-[85vh] overflow-y-auto rounded-t-2xl sm:rounded-2xl bg-[#14100A] border border-[#8a6d1f]/40 p-5">
        <div className="flex items-center justify-between gap-2">
          <div>
            <p className="text-[10px] tracking-[0.3em] text-[#D4AF37] font-bold">MELA BADGES · ਮੇਲਾ ਬੈਜ</p>
            <p data-testid="badges-count" className="text-xs text-white/50 mt-0.5">{earned} of {badges.length} collected — fun keepsakes, never points</p>
          </div>
          <button data-testid="badges-sheet-close" onClick={onClose} aria-label="Close badges"
            className="w-8 h-8 rounded-full border border-white/20 text-white/60 flex items-center justify-center shrink-0"><X size={14} /></button>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5 mt-4">
          {badges.map((b) => {
            const Icon = ICONS[b.slug] || Medal;
            return (
              <div key={b.slug} data-testid={`badge-${b.slug}`}
                className={`rounded-xl border p-3 text-center ${b.earned ? "border-[#D4AF37]/60 bg-[#1C160A]" : "border-white/10 bg-[#121212] opacity-55"}`}>
                <span className={`mx-auto w-10 h-10 rounded-full flex items-center justify-center ${b.earned ? "bg-[#D4AF37] text-black" : "bg-white/5 text-white/35"}`}>
                  {b.earned ? <Icon size={17} /> : <Lock size={14} />}
                </span>
                <p className={`text-[11px] font-black mt-2 leading-tight ${b.earned ? "text-[#D4AF37]" : ""}`}>{b.name}</p>
                <p className="text-[9px] text-[#F0C742]/60 font-bold">{b.pa}</p>
                <p className="text-[9px] text-white/45 mt-1 leading-snug">{b.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
